export const PORTALS = {
  CRYPTO: "CRYPTO",
  FOREX: "FOREX",
  GOLD: "GOLD",
  MM: "MM",
};

export const CUSTOMER_TYPES = {
  INDIVIDUAL: "INDIVIDUAL",
  CORPORATE: "CORPORATE",
};

export const CUSTOMER_SUB_TYPES = {
  LIVE: "LIVE",
  DEMO: "DEMO",
  IB: "IB",
};